export default __webpack_public_path__ + "static/media/EduAR.5d0e7858.jpg";